/** Shared staleTime constants for React Query hooks. */
export const STALE_5MIN  = 5  * 60 * 1000;
export const STALE_10MIN = 10 * 60 * 1000;
